import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the structure of a single filter item
interface Filter {
  chatFilters: number;
  chatFilterId: number;
  filterName: string;
  pattern: string;
  priority: number;
  replace: string;
}

// Define the structure of the chat filter state
interface ChatFilterState {
  filterStrings: string;
  filterRegex: RegExp | null;
  filters: Filter[];
}

// Initial state with proper typing
const initialState: ChatFilterState = {
  filterStrings: '',
  filterRegex: null,
  filters: [],
};

export const chatFilter = createSlice({
  name: 'chatFilterState',
  initialState,
  reducers: {
    // Action to add a filter string to the filterStrings
    addFilterString: (state, action: PayloadAction<string>) => {
      state.filterStrings += '|' + JSON.parse(action.payload)[0];
    },

    // Action to add a filter to the filters array
    addFilter: (state, action: PayloadAction<Filter>) => {
      state.filters.push(action.payload);
    },
  },
});

// Action creators are generated for each case reducer function
export const { addFilterString, addFilter } = chatFilter.actions;

export default chatFilter.reducer;
